module.exports = __webpack_public_path__ + "fonts/auc.953bf8f2.eot";